export const formatDateToPattern = (date: string | Date) => {
  if (!date) return "00/00/0000";

  const [year, month, day] =
    typeof date !== "string" ? date.toString().split("-") : date.split("-");
  
  return `${day}/${month}/${year}`;
};
